import { Modal } from 'react-bootstrap';
import classes from './HowGoShareWorksModal.module.css';
import { Armchair } from 'lucide-react';
import { Calendar, Truck, X } from 'react-feather';

const HowFedExWorksModal = (props) => {
	const { fedExModal, setFedExModal } = props;
	return (
		<>
			<Modal show={fedExModal} onHide={() => setFedExModal(false)}>
				<div className={classes.main}>
					<X
						onClick={() => setFedExModal(false)}
						className={classes.closeIcon}
						strikeWidth={1}
					/>
					<h3 className={classes.title1}> FedEx Home Delivery</h3>

					<p className={classes.infoText1}>
						FedEx Home Delivery is a residential shipping service that provides
						cost-effective ground shipping for smaller items with guaranteed
						delivery windows.
					</p>
					<img
						className={classes.deliveryPic}
						alt={'Fed Ex Home Delivery'}
						src={
							'https://ik.imagekit.io/kuj9zqlrx0or/Static/fedEx.webp?tr=h-1000'
						}
					/>

					<div className={classes.deliverySpec}>
						<Armchair className={classes.icon} />
						<h6 className={classes.infoText}>
							Enter your address to find out the estimated delivery time-frame
							and cost for our shipping methods
						</h6>
					</div>

					<div className={classes.deliverySpec}>
						<Calendar className={classes.icon} />
						<h6 className={classes.infoText}>
							Place your order and choose FedEx delivery. Once confirmed,
							you&apos;ll receive a tracking link for real-time updates on your
							delivery.
						</h6>
					</div>

					<div className={classes.deliverySpec}>
						<Truck className={classes.icon} />
						<h6 className={classes.infoText}>
							FedEx&apos;s dedicated team will pick up the items and ensure they
							are safely delivered to your doorstep. Your satisfaction is
							guaranteed - we will only release the payment to the seller once
							you have and are happy with item.
						</h6>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default HowFedExWorksModal;
